import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export const formatStartDate = (startDate: Date) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const start = dayjs(startDate);

    return `${start.format("MMM D, YYYY")}`;
};
